import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Row, Col, Container } from 'react-bootstrap';
import { Button, CircularProgress, SvgIcon } from '@mui/material';
import TermLifeInsuIcon from '../icons/card.svg?react';
import PremLifeInsuIcon from '../icons/Hand.svg?react';
import { GetApp as GetAppIcon } from '@mui/icons-material';
import CurrencyFormat from '../../../Helpers/Formatters/CurrencyFormat';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY, storeConsumerApplicationId } from '../../../../sessionStorage';

export default function SubmissionReview(props) {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;
    const passcode = props.formState.steps.paymentInfo.socialSecurityNumber.replace(/-/g, '').substring(5);
    const birthdate = props.formState.steps.basicInfo.birthdate;
    const applicationID = props.formState.appIdentifier;
    const accountId = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).account.accountId;
    useEffect(() => {
        fetch(`/api/ConsumerApplication/UpdateStatus?accountId=${accountId}&productType=Supplemental Health`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId,
                'X-Consumer-Application-ID': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).consumerApplicationId,
            },
            body: JSON.stringify(props.formState)
        }).then(storeConsumerApplicationId);
    }, [])
    const downloadPDF = () => {
        setLoading(true)
        fetch(`${covrServicesUrl}/api/AppStatus/GetAppPDF?passcode=${passcode}&birthdate=${birthdate}&applicationID=${applicationID}`)
            .then(response => {
                response.blob().then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'Application.pdf';
                    a.click();
                });
                setLoading(false)
            }).catch((e) => setLoading(false));
    }
    const planList = [{
        name: "Individual",
        field: "individualPremium",
    },
    {
        name: "One-parent family",
        field: "oneParentFamilyPremium",
    },
    {
        name: "Named Insured/Spouse only",
        field: "namedSpousePremium",
    },
    {
        name: "Two-parent family",
        field: "twoParentFamilyPremium",
    }
    ]
    let planName = "";
    if (props.quoter.plan) {
        planName = planList.find(x => x.field === props.quoter.plan)

    }
    return (
        <div className="SubmissionReview">

            <Container>
                {loading && <div className="main-loading-container">
                    <CircularProgress />
                </div>}

                <Row className="SubmissionSummary border-class">
                    <Col lg={8}>
                        <h4>Your Request Has Been Received</h4>
                        <p>Thank you for submitting your insuarance application.</p>
                        <p>The Aflac team will review your information and contact you with next steps.</p>
                        <h5>What comes next...</h5>
                        <h6>What to expect</h6>
                        <ul>
                            <li>Within 48 hours, an Aflac team member will reach out to you to discuss next steps</li>
                            <li>Your payment will be drafted on your selected coverage effective date</li>
                            <li>You will receive your policy (in the mail/via email)</li>
                            <li>Please contact Covr's team of experts with any questions</li>
                        </ul>
                    </Col>
                    <Col lg={4}>
                        <Row className={`d-flex justify-content-center`}>
                            <img src="/product-landing/supp/aflac-logo.png" alt="Aflac Logo" style={{ height: '73px', width: '160px' }} className="mb-2" />
                        </Row>
                        <Row className="justify-content-center">
                            <h5>Application Summary</h5>
                        </Row>

                        <Row className="ApplicationSummary">
                            <Col lg={6} className="col-6">
                                <p className="ApplicationSummaryTitle">Carrier</p>
                                <p className="ApplicationSummaryContent">Aflac</p>

                                <p className="ApplicationSummaryTitle">Premimun</p>
                                <p className="ApplicationSummaryContent"><CurrencyFormat number={props.quoter.planAmount} />/mo</p>
                            </Col>
                            <Col lg={6} className="col-6">
                                <p className="ApplicationSummaryTitle">Product</p>
                                <p className="ApplicationSummaryContent">{props.formState.steps.basicInfo.hsaAccount ? "HSA-HCI" : "Non HSA-HCI"} </p>

                                <p className="ApplicationSummaryTitle">Desired Plan</p>
                                <p className="ApplicationSummaryContent">{planName && planName.name}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Button variant="contained" size="medium" color="primary" onClick={() => downloadPDF("cancer", "A75175LPR")}>
                                <GetAppIcon className="downloadAppIcon" /> Download Application
                            </Button>
                        </Row>
                    </Col>
                </Row>

                <Row className="OtherPolicy">
                    <Col lg={6} className="align-self-center">
                        <div className="OtherPolicyTitle">
                            <h4>Other insurance products for your consideration</h4>
                            <p>
                                Please select any other type of coverage that you whould like added to your insurance application. Our team of licensed experts will help you choose the
                                benefits that are right for you and your family.
                            </p>
                        </div>

                    </Col>
                    <Col lg={6}>
                        <Row className="justify-content-center">
                            <Col lg={4} md={4} className="col-6">
                                <div className="text-center OfferCard">
                                    <Row className="justify-content-center">
                                        <SvgIcon component={TermLifeInsuIcon} color="primary" fontSize="large" className="small-icons" />
                                    </Row>
                                    <span>Term Life <br /> Insurance</span><br />
                                    <br />
                                    <span onClick={() => { navigate(`/landing/term`); }} className='link primary-color'>Quick Quote <br /> Details</span>
                                </div>
                            </Col>

                            <Col lg={4} md={4} className="col-6">
                                <div className="text-center OfferCard">
                                    <Row className="justify-content-center">
                                        <SvgIcon component={PremLifeInsuIcon} color="primary" fontSize="large" className="small-icons" />
                                    </Row>
                                    <span>Perm Life <br /> Insurance</span><br /><br />
                                    <span onClick={() => { navigate(`/landing/permanent`); }} className='link primary-color'>Quick Quote <br /> Details</span>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}
